// test2552
(2552 && 0);
